"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
const Send_1 = __importDefault(require("@mui/icons-material/Send"));
const FeesableDialog_1 = __importDefault(require("../FeesableDialog/FeesableDialog"));
const TextHelper_1 = require("../../services/TextHelper");
const useFormData_1 = require("../../hooks/useFormData");
const useSetFormData_1 = require("../../hooks/useSetFormData");
const lodash_1 = __importDefault(require("lodash"));
const InfoPopup_1 = require("./InfoPopup");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const dayjs_1 = __importDefault(require("dayjs"));
const QuotePage = ({ isOpen, setIsOpen, breakdownYearData, config, }) => {
    const [paymentChoice, setPaymentChoice] = (0, react_1.useState)();
    const [startDate, setStartDate] = (0, react_1.useState)(null);
    const [dateError, setDateError] = (0, react_1.useState)(null);
    const formData = (0, useFormData_1.useFormData)();
    const setFormData = (0, useSetFormData_1.useSetFormData)();
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = config.fees.instalmentOptions) === null || _a === void 0 ? void 0 : _a.dateSettings) {
            const dateSettings = config.fees.instalmentOptions.dateSettings;
            const currentDate = (0, dayjs_1.default)();
            const minDate = dateSettings.defaultStartDate ? (0, dayjs_1.default)(dateSettings.defaultStartDate) : null;
            const maxDate = dateSettings.latestAllowedStartDate ? (0, dayjs_1.default)(dateSettings.latestAllowedStartDate) : null;
            let defaultDate = currentDate;
            if (minDate && currentDate.isBefore(minDate)) {
                defaultDate = minDate;
            }
            else if (maxDate && currentDate.isAfter(maxDate)) {
                defaultDate = maxDate;
            }
            setStartDate(defaultDate);
        }
    }, [config]);
    const handleSubmit = () => {
        if (!paymentChoice)
            return;
        if (shouldShowDatePicker() && !startDate)
            return;
        setFormData(Object.assign(Object.assign({}, lodash_1.default.cloneDeep(formData)), { parent: Object.assign(Object.assign(Object.assign({}, formData.parent), { paymentChoice }), (shouldShowDatePicker() && {
                paymentStartDate: startDate === null || startDate === void 0 ? void 0 : startDate.format('YYYY-MM-DD'),
            })) }));
    };
    const validateDate = (date) => {
        var _a;
        if (!date) {
            setDateError('Please select a start date');
            return false;
        }
        const dateSettings = (_a = config.fees.instalmentOptions) === null || _a === void 0 ? void 0 : _a.dateSettings;
        if (!dateSettings)
            return true;
        if (dateSettings.defaultStartDate) {
            const earliestDate = (0, dayjs_1.default)(dateSettings.defaultStartDate);
            if (date.isBefore(earliestDate)) {
                setDateError(`Start date must be on or after ${earliestDate.format('DD/MM/YY')}`);
                return false;
            }
        }
        if (dateSettings.latestAllowedStartDate) {
            const latestStartDate = (0, dayjs_1.default)(dateSettings.latestAllowedStartDate);
            if (date.isAfter(latestStartDate)) {
                setDateError(`Start date must be on or before ${latestStartDate.format('DD/MM/YY')}`);
                return false;
            }
        }
        if (dateSettings.endDate) {
            const endDate = (0, dayjs_1.default)(dateSettings.endDate);
            if (date.isAfter(endDate)) {
                setDateError(`Start date must be before the payment end date`);
                return false;
            }
        }
        setDateError(null);
        return true;
    };
    const handleDateChange = (date) => {
        setStartDate(date);
        validateDate(date);
    };
    const calculateInstalmentAmount = (frequency, paymentType) => {
        var _a;
        const dateSettings = (_a = config.fees.instalmentOptions) === null || _a === void 0 ? void 0 : _a.dateSettings;
        const totalAmount = breakdownYearData.totals.total;
        if (!dateSettings || !dateSettings.endDate || !startDate) {
            return { amount: totalAmount / frequency, frequency };
        }
        const endDate = (0, dayjs_1.default)(dateSettings.endDate);
        let paymentCount = frequency;
        switch (paymentType) {
            case 'weekly':
                paymentCount = Math.floor(endDate.diff(startDate, 'weeks'));
                break;
            case 'fortnightly':
                paymentCount = Math.floor(endDate.diff(startDate, 'weeks') / 2);
                break;
            case 'monthly':
                paymentCount = endDate.diff(startDate, 'months');
                break;
            case 'quarterly':
                paymentCount = Math.floor(endDate.diff(startDate, 'months') / 3);
                break;
            case 'termly':
                paymentCount = 4;
                break;
            default:
                paymentCount = frequency;
        }
        paymentCount = Math.max(1, paymentCount);
        return {
            amount: totalAmount / paymentCount,
            frequency: paymentCount,
        };
    };
    const shouldShowDatePicker = () => {
        var _a;
        const dateSettings = (_a = config.fees.instalmentOptions) === null || _a === void 0 ? void 0 : _a.dateSettings;
        return Boolean((dateSettings === null || dateSettings === void 0 ? void 0 : dateSettings.defaultStartDate) &&
            (dateSettings === null || dateSettings === void 0 ? void 0 : dateSettings.endDate) &&
            (dateSettings === null || dateSettings === void 0 ? void 0 : dateSettings.allowUserSelection) !== false);
    };
    if (!isOpen)
        return null;
    const instalmentOptions = config.fees.instalmentOptions || {};
    const dateSettings = instalmentOptions.dateSettings;
    return ((0, jsx_runtime_1.jsx)(FeesableDialog_1.default, { open: true, size: "sm", children: (0, jsx_runtime_1.jsxs)(material_1.DialogContent, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { sx: {
                        marginTop: { xs: 6, md: 1 },
                        marginBottom: 2,
                        paddingBottom: 2,
                        borderBottom: '1px solid',
                        borderBottomColor: 'custom.surfaceDark',
                    }, children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "h6", children: [breakdownYearData.year, " ", instalmentOptions.title, " -", ' ', (0, TextHelper_1.formatNumberCurrency)(breakdownYearData.totals.total, 'never', config.terms)] }) }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 12, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: instalmentOptions.subText }) }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: shouldShowDatePicker() && ((0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, xs: 12, children: [(0, jsx_runtime_1.jsx)(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs, children: (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { sx: { width: 320 }, label: "Payment Start Date", value: startDate, onChange: handleDateChange, minDate: (0, dayjs_1.default)(dateSettings === null || dateSettings === void 0 ? void 0 : dateSettings.defaultStartDate), maxDate: (0, dayjs_1.default)(dateSettings === null || dateSettings === void 0 ? void 0 : dateSettings.latestAllowedStartDate), format: "DD/MM/YY", slotProps: {
                                                textField: {
                                                    fullWidth: true,
                                                    error: !!dateError,
                                                    helperText: dateError ||
                                                        (dateSettings === null || dateSettings === void 0 ? void 0 : dateSettings.helperText) ||
                                                        '',
                                                    size: 'small',
                                                },
                                                actionBar: {
                                                    actions: ['today'],
                                                },
                                            } }) }), dateSettings && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "caption", color: "text.secondary", sx: { mt: 1, display: 'block' }, children: ["All payments must fall between ", (0, dayjs_1.default)(dateSettings.defaultStartDate).format('DD/MM/YY'), " and ", (0, dayjs_1.default)(dateSettings.endDate).format('DD/MM/YY'), ". Please contact the school if you wish to make alternative payment arrangements outside of these dates."] }))] })) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 12, children: (0, jsx_runtime_1.jsx)(material_1.Stack, { children: instalmentOptions === null || instalmentOptions === void 0 ? void 0 : instalmentOptions.available.map((option) => {
                                    var _a, _b, _c, _d, _e, _f, _g;
                                    return ((0, jsx_runtime_1.jsxs)(material_1.ListItemButton, { onClick: () => {
                                            setPaymentChoice(option.key);
                                            if (startDate)
                                                validateDate(startDate);
                                        }, sx: { display: 'flex', alignItems: 'center', gap: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.Checkbox, { checked: option.key === paymentChoice }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { flex: 1, display: 'flex', flexDirection: 'column' }, children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body2", fontWeight: 'bold', children: [(0, jsx_runtime_1.jsxs)("strong", { children: [option.label, " (", calculateInstalmentAmount(option.frequency, option.key).frequency, ' ', "instalments)"] }), option.info && ((0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: option.key, infos: [option.info] }))] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "text.secondary", children: option.subLabel })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", fontWeight: 'bold', sx: { ml: 'auto' }, children: (0, jsx_runtime_1.jsx)("strong", { children: (0, TextHelper_1.formatNumberCurrency)((0, TextHelper_1.roundNumber)((_a = calculateInstalmentAmount(option.frequency, option.key)) === null || _a === void 0 ? void 0 : _a.amount, (_d = (_c = (_b = config === null || config === void 0 ? void 0 : config.fees) === null || _b === void 0 ? void 0 : _b.instalmentOptions) === null || _c === void 0 ? void 0 : _c.rounding) === null || _d === void 0 ? void 0 : _d.type, (_g = (_f = (_e = config === null || config === void 0 ? void 0 : config.fees) === null || _e === void 0 ? void 0 : _e.instalmentOptions) === null || _f === void 0 ? void 0 : _f.rounding) === null || _g === void 0 ? void 0 : _g.precision), instalmentOptions.rounding.displayDecimals, config.terms) }) })] }, option.key));
                                }) }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 12, children: instalmentOptions.instructions }), config.terms.extrasConfirmationMessage && ((0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 12, children: (0, jsx_runtime_1.jsx)(material_1.Alert, { sx: { fontSize: '16px' }, severity: "info", children: config.terms.extrasConfirmationMessage }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, xs: 12, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", type: "button", size: "large", sx: { paddingLeft: 4, paddingRight: 4 }, "aria-label": "submit to school", onClick: handleSubmit, endIcon: (0, jsx_runtime_1.jsx)(Send_1.default, {}), disabled: !paymentChoice ||
                                        (shouldShowDatePicker() && (!startDate || Boolean(dateError))), children: "Submit" }), (0, jsx_runtime_1.jsx)(material_1.Button, { type: "button", size: "large", sx: { marginLeft: 2 }, "aria-label": "cancel", onClick: () => setIsOpen(false), children: "Cancel" })] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 12, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                    fontSize: 'small',
                                    color: 'custom.textLight',
                                    fontStyle: 'italic',
                                    lineHeight: '13px',
                                }, children: instalmentOptions.notes }) })] })] }) }));
};
exports.QuotePage = QuotePage;
